import React from 'react';
import WalletConnection from './connect';

const App = () => {
  return (
    <div className="container">
      <div className="nftsB">
      <h1>SORY AIRDROP HAS BEEN CLOSED CHECK UPDATE ON LAST POST</h1>
      <WalletConnection />
    </div></div> 
  );
};

export default App;
